export default "__VITE_ASSET__CrNF71_T__"